import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useTitle } from '../../hooks/useTitle'
import { toast } from 'react-toastify'
import api from '../../services/api'
import * as S from './styles'
import Select from '../../components/Select'
import { IMAGE_URL } from '../../constants'
import { useAuth } from '../../context/AuthContext'
import LoadingBackground from '../../components/LoadingBackground'
import { verifyAdvancedPlanImage } from '../../util/verifyAdvancedPlan'

const Invite = () => {
  const { hash } = useParams()
  const [isLoading, setIsLoading] = useState(false)
  const [isCPF, setIsCPF] = useState(false)
  const [registerDone, setRegisterDone] = useState(false)
  const [backgroundImage, setBackgroundImage] = useState('/assets/images/ilustracao-login.svg')
  const navigate = useNavigate()
  /* eslint-disable no-unused-vars */
  const { register, handleSubmit, setValue, getValues, formState: { errors } } = useForm()
  const customerInfo = JSON.parse(localStorage.getItem('customerInfo'))

  const getPageImage = async () => {
    const image = verifyAdvancedPlanImage(customerInfo)
    setBackgroundImage(image ? image : '/assets/images/ilustracao-login.svg')
  }

  useEffect(() => {
    if (customerInfo) {
      getPageImage()
    }
  }, [])

  const enableNaturalPerson = hash.charAt(0) === '1';

  useEffect(() => {
    if (registerDone) {
      setTimeout(() => {
        navigate('/login')
      }, 2000)
    }
  }, [registerDone, navigate])

  const handleInvite = async data => {
    const { type, code, name, mail } = data
    var codeCopy = code;
    setIsLoading(true)

    const id = toast.loading('Efetuando seu cadastro...')

    const json = {
      Type: type,
      Code: cleanNumeric(codeCopy),
      Name: name,
      Mail: mail,
    }

    try {
      const response = await api.post(`/Customer/AcceptInvite/${encodeURIComponent(hash)}`, json);

      const successMessage = (response.data && response.data.successMessages && response.data.successMessages.length > 0)
        ? response.data.successMessages[0]
        : 'Cliente cadastrado com sucesso!';

      toast.update(id, {
        render: successMessage,
        type: 'success',
        isLoading: false,
        delay: 750,
        autoClose: 2000,
      });

      setRegisterDone(true);

    } catch (error) {
      let errorMessage = 'Não foi possível concluir o cadastro. Por favor, tente novamente.';

      if (error.response) {
        if (error.response.data && error.response.data.errorMessages && error.response.data.errorMessages.length > 0) {
          errorMessage = 'Erro ao efetuar o cadastro: ' + error.response.data.errorMessages.join(', ');
        } else if (error.response.data && typeof error.response.data === 'string' && error.response.data.trim() !== '') {
          errorMessage = error.response.data;
        }
        console.error('API Error:', error.response.status, error.response.data);
      } else if (error.request) {
        errorMessage = 'Falha na comunicação com o servidor. Verifique sua conexão e tente novamente.';
        console.error('Network Error - No response received:', error.request);
      } else {
        errorMessage = 'Ocorreu um erro ao enviar a solicitação. Por favor, tente novamente.';
        console.error('Request Setup Error:', error.message);
      }

      toast.update(id, {
        render: errorMessage,
        type: 'error',
        isLoading: false,
        delay: 750,
        autoClose: 5000,
      });
    }

    setIsLoading(false)
  }

  const handleInviteError = (errors, e) => {
    Object.entries(errors).forEach(entry => {
      toast.warning(entry[1].message)
    })
  }

  const handleChangeCharacteristic = (value) => {
    if (enableNaturalPerson) {
      if (value === 'F') { setIsCPF(true) } else { setIsCPF(false) }
    } else {
      if (value === 'F') {
        toast.warning('Característica da operação não disponível para pessoa física')
      }

      setIsCPF(false)
      value = 'J'
    }
  }

  const cleanNumeric = (value = '') => String(value).replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

  const formatCPFValue = (numericValue = '') => {
    var cleanNumericVal = cleanNumeric(numericValue);
    const v = cleanNumericVal.substring(0, 11); // Already cleaned and length-limited
    if (!v) return '';
    if (v.length <= 3) return v; // 123
    if (v.length <= 6) return `${v.slice(0, 3)}.${v.slice(3)}`; // 123.456
    if (v.length <= 9) return `${v.slice(0, 3)}.${v.slice(3, 6)}.${v.slice(6)}`; // 123.456.789
    return `${v.slice(0, 3)}.${v.slice(3, 6)}.${v.slice(6, 9)}-${v.slice(9, 11)}`; // 123.456.789-01
  };

  const formatCNPJValue = (value = '') => {
    // CORREÇÃO: Garante letras maiúsculas e aceita letras/números (mude também a função cleanNumeric se necessário)
    var cleanAlphanumericVal = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    
    const v = cleanAlphanumericVal.substring(0, 14); // Limita aos 14 caracteres alfanuméricos
    if (!v) return '';
    if (v.length <= 2) return v; 
    if (v.length <= 5) return `${v.slice(0, 2)}.${v.slice(2)}`; 
    if (v.length <= 8) return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5)}`; 
    if (v.length <= 12) return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(8)}`; 
    return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(8, 12)}-${v.slice(12, 14)}`; 
  };

  useTitle('Zaub')

  return (
    <S.Invite backgroundImage={backgroundImage}>
      <S.InviteContainer>
        <S.InviteWrapper>
          <S.InviteImageWrapper>
            <S.InviteImage src={backgroundImage} alt='Ilustração da tela de convite.'></S.InviteImage>
          </S.InviteImageWrapper>
          <S.InviteInner>
            <S.InviteLogoWrapper>
              <S.InviteLogo src={customerInfo?.logo ? `${IMAGE_URL}${customerInfo.logo}` : '/assets/images/logo-zaub.png'} />
            </S.InviteLogoWrapper>
            <S.InviteTitle>Vamos fazer o seu cadastro?</S.InviteTitle>
            {/* <S.InviteText>Faça seu cadastro e aproveite!</S.InviteText> */}
            <S.InviteBox>
              <form onSubmit={handleSubmit(handleInvite, handleInviteError)}>
                <S.HomeField>
                  <S.HomeFieldFixLabel>
                    Característica da operação:
                  </S.HomeFieldFixLabel>
                  <Select
                    name='type'
                    register={register}
                    required
                    message='Característica da operação é obrigatório'
                    onChange={e => handleChangeCharacteristic(e.target.value)}
                  >
                    {enableNaturalPerson ? (
                      <>
                        <option value='J'>Jurídica</option>
                        <option value='F'>Física</option>
                      </>
                    ) : (
                      <option value='J'>Jurídica</option>
                    )}
                  </Select>
                </S.HomeField>
                <S.HomeField>
                  <S.HomeFieldInput
                    type="text"
                    placeholder="&nbsp;"
                    {...register('code', {
                      required: isCPF ? 'CPF é obrigatório' : 'CNPJ é obrigatório',
                      validate: value => {
                        const cleanStr = isCPF 
                          ? (value || "").replace(/\D/g, "")
                          : (value || "").replace(/[^a-zA-Z0-9]/g, "");
                        
                        if (isCPF) {
                          return cleanStr.length === 11 || 'CPF deve conter 11 números.';
                        }
                        return cleanStr.length === 14 || 'CNPJ deve conter 14 caracteres.';
                      }
                    })}

                    onChange={e => {
                      const rawValue = e.target.value;
                      const cleanVal = isCPF 
                        ? rawValue.replace(/\D/g, "")
                        : rawValue.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
                      
                      const currentMaxLength = isCPF ? 11 : 14;
                      const truncatedVal = cleanVal.slice(0, currentMaxLength);

                      setValue('code', truncatedVal, { shouldValidate: true });
                      e.target.value = truncatedVal;
                    }}
                    onPaste={e => {
                      e.preventDefault();
                      const pastedText = e.clipboardData.getData('text/plain');
                      const cleanVal = isCPF 
                        ? pastedText.replace(/\D/g, "")
                        : pastedText.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
                      
                      const currentMaxLength = isCPF ? 11 : 14;
                      const truncatedVal = cleanVal.slice(0, currentMaxLength);

                      setValue('code', truncatedVal, { shouldValidate: true });
                      e.target.value = truncatedVal;
                    }}
                    value={isCPF ? formatCPFValue(getValues('code')) : formatCNPJValue(getValues('code'))}
                    title={isCPF ? 'CPF (somente números)' : 'CNPJ (letras e números)'}
                  />
                  <S.HomeFieldLabel>
                    {isCPF === true ? 'Seu CPF:' : 'Seu CNPJ:'}
                  </S.HomeFieldLabel>
                </S.HomeField>
                <S.HomeField>
                  <S.HomeFieldInput
                    type='text'
                    placeholder='&nbsp;'
                    {...register('name', { required: isCPF === true ? 'Nome é obrigatório' : 'Razão social é obrigatório' })}
                  />
                  <S.HomeFieldLabel>
                    {isCPF === true ? 'Seu nome:' : 'Sua razão social:'}
                  </S.HomeFieldLabel>
                </S.HomeField>
                <S.HomeField>
                  <S.HomeFieldInput
                    type='text'
                    placeholder='&nbsp;'
                    {...register('mail', { required: 'E-mail é obrigatório' })}
                  />
                  <S.HomeFieldLabel>
                    Seu e-mail:
                  </S.HomeFieldLabel>
                </S.HomeField>
                <S.InvitePasswordInfoText>A senha será os 6 primeiros dígitos do seu {isCPF === true ? 'CPF' : 'CNPJ'}.</S.InvitePasswordInfoText>
                <S.InviteButton type='submit' disabled={isLoading}>
                  Cadastrar
                </S.InviteButton>
              </form>
            </S.InviteBox>
          </S.InviteInner>
        </S.InviteWrapper>
      </S.InviteContainer>
    </S.Invite>
  )
}

export default Invite
